<template>
    <div class="text-center">
      <v-dialog dark v-model="dialog" width="800"> 

        <v-card>
        <v-card-title class="text-h5" style="background-color: #161d30;">
            <p class="text-center ma-0"> Detalles del deposito:  </p>
        </v-card-title>

        <v-card-text style="background-color: #283045;">  
            <p class="my-0"> <b>ID Caja:</b> {{ cajita.caja_id }} </p>
            <p class="my-0"> <b>Estado:</b> {{ cajita.estado }} </p>
            <p class="my-0"> <b>Monto recaudado:</b> {{ cajita.monto_recaudado }} bs. </p>
            <p class="my-0"> <b>Monto depositado:</b> {{ cajita.monto_depositado }} bs. </p>
            <p class="my-0"> <b>Fecha deposito:</b> {{ cajita.fecha_deposito }} </p>
            <p class="my-0"> <b>Comprobante:</b> {{ cajita.comprobante }} </p>
            <p class="my-0"> <b>Creador:</b> {{ cajita.created_by }} </p>
            <p class="my-0"> <b>Creado:</b> {{ cajita.created_at }} </p> 
            <p class="my-0"> <b>Sede destino:</b> {{ cajita.sede?cajita.sede.nombre:cajita.sede_id }} </p> 
            <p class="my-0"> <b>Sede:</b> {{ cajita.sede_caja?cajita.sede_caja.nombre:'' }} </p> 

            <p class="my-0"> <b>Verificado por:</b> {{ cajita.verificado_by }} </p> 
            <p class="mt-0"> <b>Fecha verificacion:</b> {{ cajita.fecha_verificacion }} </p> 

            <small> Imagen del comprobante: </small>
            <object :data="getdatauri(cajita.archivo)" type="image/png" width="750"></object>
            <v-btn v-if="cajita.archivo" small :disabled="loading" :loading="loading" tile color="orange" class="mr-4" @click="saveArchivo()" > descargar comprobante </v-btn>


            <v-progress-linear v-if="loading" indeterminate color="green darken-2"></v-progress-linear>

            <div class="text-center pt-8">
                <v-btn :disabled="loading" :loading="loading" tile color="success" class="mr-4" @click="dialog =!dialog" > Cerrar </v-btn>
            </div>
        </v-card-text>  
      </v-card> 
      </v-dialog>
 
    </div>
  </template>

<script> 
import xaxios from '@/xaxios';

export default {
  data () {
    return {
      dialog: false,
      valid: true,
      loading: false,
      cajita: {},
      headers:[
        { text: 'ID', value: 'id' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Detalle', value: 'detalle' },
        { text: 'Transaccion', value: 'transaccion' },
        { text: 'Monto', value: 'monto' },
        { text: 'Fecha', value: 'created_at' },
      ]
    }
  }, 
  components:{},  
  methods: {
    openmodal(depoid){
        this.dialog = true;   
        this.cajita = {};
        this.getData(depoid);
    },
    getdatauri(archivo){
        if(!archivo) return '';
        return `data:${archivo.mimetype};base64,${archivo.file64}`
    },
    saveArchivo(){
        const imgUri = this.getdatauri(this.cajita.archivo);
        const link = document.createElement('a')
        document.body.appendChild(link)

        link.href = imgUri
        link.target = '_self'
        link.fileName = `comprobante.${this.cajita.archivo.extencion}`;
        link.download = `comprobante.${this.cajita.archivo.extencion}`;
        link.click()
    },
    async getData(depoid){
        this.loading = true;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${depoid}`; 
        const res = await xaxios.get(url).then(x=>x).catch(x=>x);
        if(res && res.data ){
            window.console.log('res',res.data);  
            this.cajita = {...res.data};
        }
        this.loading = false;
    }
  }
}
</script>